/* @jsxRuntime classic */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { matchDriverLandingPath } from './features/driver/utils/driverDeepLinkPath';
import './styles/theme.css';
import './styles/route-map.css';
import './styles/shadcn.css';
import './styles/sales-order-toolbar.css';
import './styles/sales-order-toolbar-permissions.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
const match = matchDriverLandingPath(window.location.pathname);

if (match.type === 'work') {
  if (window.location.pathname !== match.canonicalPath || window.location.search || window.location.hash) {
    window.history.replaceState(null, '', match.canonicalPath);
  }
  import('./features/driver/pages/WorkDeepLinkLandingPage').then(({ default: Landing }) => {
    root.render(<React.StrictMode><Landing token={match.token} /></React.StrictMode>);
  });
} else {
  import('./TmsAppRoot').then(({ default: TmsAppRoot }) => {
    root.render(<React.StrictMode><TmsAppRoot /></React.StrictMode>);
  });
}
